/* global  */ // tUrl等のグローバル変数を宣言する
import './_smoothScroll' // スムーズスクロール
// import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,.' + accBtn + '-close,#' + accBtn + ' a,#overlay').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,.' + accBtn + '-close,#overlay').toggleClass('active')
  })
  $('.pulldown').hover(function() {
    $('.hide-menu,.open-mark').toggleClass('active')
  })
  $('.l-animebtn').on('click', function() {
    $('.hide-menu-ham,.hide-menu-ham-bg').toggleClass('active')
  })
  $('.hide-menu-ham-bg').on('click', function() {
    $('.hide-menu-ham,.l-animebtn,.hide-menu-ham-bg').removeClass('active')
  })
  $('.l-animebtn,.hide-menu-ham-bg').on('click', function() {
    $('body').toggleClass('lock')
  })
  $('.accordion1').on('click', function() {
    $('.accordion1-detail,.open-img1,.before1,.after1').toggleClass('action')
  })
  $('.accordion2').on('click', function() {
    $('.accordion2-detail,.open-img2,.before2,.after2').toggleClass('action')
  })
  $('.accordion3').on('click', function() {
    $('.accordion3-detail,.open-img3,.before3,.after3').toggleClass('action')
  })
  if ($('.error')[0]) {
    $('.mw_wp_form').addClass('mw_wp_form_error')
  }
  //modal
  //modal
  //modal
  //modal
  //YouTube（仮）をクリックしたら
  $('.open-img').click(function() {
    // ボディをロックするクラスを与える。toggleだと難しくなる
    $('body').addClass('lock')
    //動画を設置したセクション内の最後に<div id="modal-bg"></div>を挿入
    $('.movie').append('<div id="modal-bg"></div>')

    //画面中央を計算する関数を実行
    modalResize()

    //動画を表示
    $('#modal-bg,#modal-main').fadeIn('slow')

    //背景をクリックしたら動画を閉じる
    $('#modal-bg,#modal-main').click(function() {
      //ボディからクラスをとる
      $('body').removeClass('lock')
      //フェードアウトさせる
      $('#modal-main,#modal-bg').fadeOut('slow', function() {
        //挿入した<div id="modal-bg"></div>を削除
        $('#modal-bg').remove()
      })
    })

    //画面の左上からmodal-mainの横幅・高さを引き、その値を2で割ると画面中央の位置が計算できます
    $(window).resize(modalResize)
    function modalResize() {
      var w = $(window).width()
      var h = $(window).height()

      var cw = $('#modal-main').outerWidth()
      var ch = $('#modal-main').outerHeight()

      //取得した値をcssに追加する
      $('#modal-main').css({
        left: (w - cw) / 2 + 'px',
        top: (h - ch) / 2 + 'px'
      })
    }
  })
})
